import { render } from "./index.vue?vue&type=template&id=68796483&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=68796483&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68796483"]])

export default __exports__